import { render, staticRenderFns } from "./MonthComponent.vue?vue&type=template&id=5158e12c"
import script from "./MonthComponent.vue?vue&type=script&lang=js"
export * from "./MonthComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports